import styled from "styled-components";

const SocialLinkDiv = styled.div`
  padding-left: 0;
  padding-right: 16px;
`;

export default SocialLinkDiv;